var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"15dabe979d8830fcd702bb1465123ed4a36b1da0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hoyer-xp@harlapp-gmbh"]={id:"15dabe979d8830fcd702bb1465123ed4a36b1da0"};
      